import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]

  connect() {
    this.element.style.setProperty('--animate-duration', '0.5s')
  }

  remove() {
    this.element.classList.remove('animate__fadeIn')
    this.element.classList.add('animate__fadeOut')

    this.element.style.setProperty('--animate-duration', '0.5s')

    this.element.addEventListener('animationend', () => {
      this.element.remove()
    }, { once: true })
  }
}